export default () => {
  window.scrollTo({ top: 0, left: 0 })
}
